import CurrencyValueUIModel from './currency-value';
import SeatmapSectionUIModel from './seatmap-section';
import SegmentUIModel from './segment';

import seatmapSectionCodes from '../../scripts/constants/seatmap-section-codes';

class SeatmapUIModel {
  /**
   * constructor
   * @param {Object} options
   */
  constructor({
    seatSelectionFee = null,
    sections = [],
    segment = {},
    status = '',
    distribution = '',
    seatSummary = {},
    isCorporateSeatMap = false,
    isGenericSeatMap = false,
  }) {
    this.isAvailable = status === 'AVAILABLE';
    this.sections = sections._collection.map(section => {
      section.isPremierLight = segment.isPremierLight;
      return new SeatmapSectionUIModel(section);
    });
    this.segment = new SegmentUIModel({ 'segment': segment });
    this.distribution = distribution;
    this.isCorporateSeatMap = isCorporateSeatMap;
    this.isGenericSeatMap = isGenericSeatMap;

    let hasFirstClass = false;
    for (let i = 0; i < sections.length; i++) {
      if (this.sections[i].code === seatmapSectionCodes.FIRST_CLASS) {
        hasFirstClass = true;
        break;
      }
    }

    this.hasFirstClassSection = hasFirstClass;
    this.seatSummary = seatSummary;
    this.seatSelectionFee = null;

    if (seatSelectionFee) {
      this.seatSelectionFee = new CurrencyValueUIModel(seatSelectionFee);
    }
  }

  getOperatingCarrier() {
    return this.segment.getOperatingCarrier();
  }

  getAircraftType() {
    return this.segment.getAircraftType();
  }

  getOperatingFlightCode() {
    return this.segment.getOperatingFlightCode();
  }

  getSections() {
    return this.sections;
  }

  getSeatSummary() {
    return this.seatSummary;
  }

  getSegment() {
    return this.segment;
  }

  getSegmentCode() {
    return this.segment.segmentcode;
  }

  getSeatSelectionFee() {
    return this.seatSelectionFee;
  }

  getDepartureAirportCode() {
    const routes = this.segment.getRoutes();
    return routes.departureAirport;
  }

  getArrivalAirportCode() {
    const routes = this.segment.getRoutes();
    return routes.arrivalAirport;
  }

  /**
   * @return {Obj} seatmap's prices
  **/
  getPricesSeatMap() {
    return {
      'TOURIST': this.seatSelectionFee !== null ? this.seatSelectionFee.total : 0.0,
      'PREFERRED': this.seatSummary.lowestPreferedPrice,
      'EXIT_ROW': this.seatSummary.lowestExitRowPrice,
      'AM_PLUS': this.seatSummary.price,
    };
  }

  /**
   * @return {Boolean}
   */
  isOperatingAM() {
    return this.getOperatingCarrier() === 'AM' && this.getAircraftType() !== null;
  }

  isOperatingDelta() {
    return this.getOperatingCarrier() === 'DL' && this.getAircraftType() !== null;
  }

  /**
   * @return {Boolean}
   */
  isBasicFareFamily() {
    return this.segment.isBasicFareFamily();
  }
}

export default SeatmapUIModel;
